import { useTranslation } from "react-i18next";
import { AreaChart, BarChart3 } from "lucide-react";

const ITEMS = [
  { key: "area", icon: AreaChart, tKey: "dashboard.chart.area" },
  { key: "bars", icon: BarChart3, tKey: "dashboard.chart.bars" },
];

// حاوية Segmented بأسلوب "بئر" — Inset مزدوج يوحي بأن الأزرار غاطسة قليلاً.
const TRACK_3D = {
  boxShadow:
    "inset 0 3px 6px rgba(0,0,0,0.28), inset 0 -1px 0 rgba(255,255,255,0.06),"
    + " 0 1px 0 rgba(255,255,255,0.05)",
};

// زر نشط بارز 3D — تدرّج + حلقة داخلية علوية بيضاء + وهج + ظل خارجي.
const ACTIVE_3D = {
  background: "linear-gradient(180deg, hsl(var(--primary)) 0%, hsl(var(--primary) / 0.82) 100%)",
  boxShadow:
    "0 6px 12px hsl(var(--primary) / 0.45), 0 2px 4px rgba(0,0,0,0.35),"
    + " inset 0 1.5px 0 rgba(255,255,255,0.45), inset 0 -2px 4px rgba(0,0,0,0.22)",
  textShadow: "0 1px 0 rgba(0,0,0,0.25), 0 2px 6px rgba(0,0,0,0.35)",
};

// أيقونة نشطة بظل انسدال أنيق لتعزيز الإحساس بالبروز.
const ICON_3D = { filter: "drop-shadow(0 1.5px 2px rgba(0,0,0,0.35))" };

// مبدّل مقاطع 3D احترافي — الحاوية غاطسة، الزر النشط بارز ومتوهّج.
export const ChartModeToggle = ({ mode, setMode }) => {
  const { t } = useTranslation();
  return (
    <div className="inline-flex shrink-0 rounded-full bg-muted/60 p-1" style={TRACK_3D}>
      {ITEMS.map(({ key, icon: Icon, tKey }) => {
        const on = mode === key;
        return (
          <button
            key={key}
            type="button"
            data-testid={`chart-mode-${key}`}
            onClick={() => setMode(key)}
            style={on ? ACTIVE_3D : undefined}
            className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[12px] font-bold transition-all duration-300 sm:gap-1.5 sm:px-3.5 sm:py-1.5 sm:text-[13px] ${
              on
                ? "-translate-y-px text-primary-foreground"
                : "text-muted-foreground hover:text-foreground"
            }`}
          >
            <Icon className="h-3.5 w-3.5" style={on ? ICON_3D : undefined} />
            {t(tKey)}
          </button>
        );
      })}
    </div>
  );
};
